export default __webpack_public_path__ + "static/013a-d24bbcc3b32be5f00be494b3e95454ab.jpg";